import { getToday, getSubMonthsDate, getTodayPlus7 } from '../libs/date'

export const DATE_FORMAT = 'dd/MM/yyyy'
export const MIN_CODE_LENGTH_TO_SEARCH = 4
export const CODE_VALIDATION_FN = code =>
  code === '' || code.length < MIN_CODE_LENGTH_TO_SEARCH
export const MULTILINE_MAX_LENGTH = 500
export const ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50]
export const ADDRESS_LIST_DEFAULT_ROWS_PER_PAGE =
  ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS[0]
export const SHIPPINGS_TABLE_DEFAULT_PAGE = 0
export const SHIPPINGS_TABLE_DEFAULT_ROWS_PER_PAGE =
  ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS[1]
export const INCIDENTS_TABLE_DEFAULT_PAGE = 0
export const INCIDENTS_TABLE_DEFAULT_ROWS_PER_PAGE =
  ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS[1]
export const RETURNS_TABLE_DEFAULT_PAGE = 0
export const RETURNS_TABLE_DEFAULT_ROWS_PER_PAGE =
  ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS[1]
export const UNSCHEDULED_PICKUP_TABLE_DEFAULT_ROWS_PER_PAGE =
  ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS[
    ADDRESS_LIST_ROWS_PER_PAGE_OPTIONS.length - 1
  ]

export const START_DATE_QUARTER_DATA = getSubMonthsDate(3)
export const START_DATE_LAST_MONTH = getSubMonthsDate(1)
export const TODAY_DATE = getToday()
export const TODAY_PLUS_7_DATE = getTodayPlus7()

export const SHIPPINGS_STATIC_DEFAULT_FILTERS = {
  postalCodeSource: 'destin',
  dateFrom: START_DATE_QUARTER_DATA,
  dateTo: TODAY_PLUS_7_DATE,
  shippingsPage: SHIPPINGS_TABLE_DEFAULT_PAGE,
  shippingsRowsPerPage: SHIPPINGS_TABLE_DEFAULT_ROWS_PER_PAGE,
  shippingsSortType: 'desc',
  shippingsSortColumn: 'shippingDate',
  incidentsPage: INCIDENTS_TABLE_DEFAULT_PAGE,
  incidentsRowsPerPage: INCIDENTS_TABLE_DEFAULT_ROWS_PER_PAGE,
  incidentsSortType: 'desc',
  incidentsSortColumn: 'shippingDate',
  returnsPage: RETURNS_TABLE_DEFAULT_PAGE,
  returnsRowsPerPage: RETURNS_TABLE_DEFAULT_ROWS_PER_PAGE,
  returnsSortType: 'desc',
  returnsSortColumn: 'shippingDate',
  unscheduledPickupSortType: 'desc',
  unscheduledPickupSortColumn: 'shippingDate',
  unscheduledPickupRowsPerPage: UNSCHEDULED_PICKUP_TABLE_DEFAULT_ROWS_PER_PAGE,
  selectedTracking: 'shipping',
}

export const SHIPPINGS_TABLE_HEADER_ORDER = [
  'shippingCode',
  'manifestDate',
  'shippingStatusCode',
  'clientCenterCode',
  'clientReference',
  'senderAddress2',
  'recipientAddress2',
  'recipientName',
]

export const SHIPPINGS_TABLE_HEAD_CELLS = [
  {
    id: 'shippingCode',
    sortable: false,
    extraClass: 'big',
  },
  {
    id: 'shippingDate',
    sortable: true,
    extraClass: 'small',
  },
  {
    id: 'shippingStatusCode',
    sortable: true,
  },
  { id: 'clientCenterCode', sortable: true },
  { id: 'clientReference', sortable: false },
  { id: 'senderAddress2', sortable: true },
  { id: 'recipientAddress2', sortable: true },
  { id: 'recipientName', sortable: true },
]

export const SHIPPINGS_TABLE_HEAD_CELLS_NO_SORTABLE = [
  { id: 'shippingCode', extraClass: 'big' },
  { id: 'shippingDate', extraClass: 'small' },
  { id: 'shippingStatusCode' },
  { id: 'clientCenterCode' },
  { id: 'clientReference' },
  { id: 'senderAddress2' },
  { id: 'recipientAddress2' },
  { id: 'recipientName' },
]

export const SHIPPINGS_RECORDING_TABLE_HEAD_CELLS = [
  { id: 'status' },
  { id: 'file_name', extraClass: 'big', sortable: true },
  { id: 'upload_date', extraClass: 'small', sortable: true },
  { id: 'success_lines', extraClass: 'small', sortable: false },
  { id: 'error_lines', extraClass: 'small', sortable: false },
  { id: 'actionButtons' },
]

export const SHIPPINGS_RECORDING_TABLE_HEADER_ORDER = [
  'status',
  'file_name',
  'upload_date',
  'success_lines',
  'error_lines',
  'actionButtons',
]

export const IMPORTED_CONTACTS_TABLE_HEAD_CELLS = [
  { id: 'status' },
  { id: 'file_name', extraClass: 'big' },
  { id: 'upload_date', extraClass: 'small', sortable: true },
  { id: 'upload_hour', extraClass: 'small', sortable: true },
  { id: 'success_lines', extraClass: 'small', sortable: false },
  { id: 'error_lines', extraClass: 'small', sortable: false },
  { id: 'actionButtons' },
]

export const IMPORTED_CONTACTS_TABLE_HEADER_ORDER = [
  'status',
  'file_name',
  'upload_date',
  'upload_hour',
  'success_lines',
  'error_lines',
  'actionButtons',
]

export const AGENDA_TABLE_HEADER_ORDER = [
  'contact-client-code',
  'name-company',
  'phone',
  'email',
  'address',
]

export const AGENDA_TABLE_HEAD_CELLS = [
  { id: 'contact-client-code', extraClass: 'medium', sortable: true },
  { id: 'name-company', extraClass: 'medium', sortable: true },
  { id: 'phone', extraClass: 'small', sortable: true },
  { id: 'email', extraClass: 'small', sortable: true },
  { id: 'address', extraClass: 'small', sortable: true },
]

export const REPORTS_CONFIG_TABLE_HEADER_ORDER = [
  'name',
  'description',
  'subscription',
  //'type',
  //'settings',
]

export const REPORTS_CONFIG_TABLE_HEAD_CELLS = [
  {
    id: 'name',
    sortable: true,
    extraClass: 'small',
  },
  {
    id: 'description',
    sortable: true,
    extraClass: 'big',
  },
  {
    id: 'subscription',
    sortable: false,
  },
  // {
  //   id: 'type',
  //   sortable: false,
  // },
  // {
  //   id: 'settings',
  //   sortable: false,
  // },
]

export const REPORTS_CONFIG_TABLE_HEAD_CELLS_NO_SORTABLE = [
  { id: 'name', extraClass: 'big' },
  { id: 'description', extraClass: 'small' },
  { id: 'subscription' },
  //{ id: 'type' },
  //{ id: 'settings' },
]

export const REPORTS_TABLE_HEADER_ORDER = ['name', 'date', 'download']

export const REPORTS_TABLE_HEAD_CELLS = [
  {
    id: 'name',
    sortable: false,
    extraClass: 'big',
  },
  {
    id: 'date',
    sortable: false,
    extraClass: 'small',
  },
  {
    id: 'download',
    sortable: false,
  },
]

export const REPORTS_TABLE_HEAD_CELLS_NO_SORTABLE = [
  { id: 'name', extraClass: 'big' },
  { id: 'date', extraClass: 'small' },
  { id: 'download' },
]

export const REPORT_TYPES = [
  { id: 'WEB', text: 'Web' },
  {
    id: 'FTP',
    text: 'FTP',
  },
  { id: 'Email', text: 'Email' },
]

//business-constants

// TODO: change names for NEW, DEFAULT, AGENDA
export const ADDRESS_STATES = {
  NEW: 'NEW',
  EXISTING: 'EXISTING',
  AT_PICKUP_POINT: 'AT_PICKUP_POINT',
}

export const ADDRESS_SOURCES = {
  clientCentersList: 'clientCentersList',
  newAddress: 'newAddress',
  pickUpPoint: 'pickUpPoint',
}

export const ADDRESS_TYPE_CODE = {
  ORIGIN: 'ORIGIN',
  DESTIN: 'DESTIN',
}

export const STEPS = {
  FROM: 'from',
  TO: 'to',
  SHIPMENT: 'shipment',
  CUSTOMS: 'customs',
  SERVICES: 'services',
  SUMMARY: 'summary',
}

export const OLD_SHIPPING_STATUS_CODES = {
  manifested: '0000',
  incident: '1600',
  inTransit: '0900',
  delivered: '2100',
}

export const SHIPPING_STATUS_CODES = {
  manifested: 'WEB0000', //Grabado
  collected: 'WEB0500', //Recogido
  inTransit: 'WEB1000', //En tránsito
  delivering: 'WEB1500', //En reparto
  incidentDelivering: 'WEB1600', //En reparto con incidencia
  delivered: 'WEB2100', //Entregado
  pudo: 'WEB2300', //Entregado en Punto CTT
  returned: 'WEB2500', //Devuelto
  cancelled: '3000', // Anulado
  onHold: 'WEB...', //En pudo - Todavía sin el código definitivo
  //TODO: REVISAR NOMENCLATURA Y ELIMINAR ESTOS 2 REL. INCIDENCIAS
  //eliminar esta constante y que se obtenga de resp API
  failedDelivery: 'WEB1600',
  incidents: 'incidents',
}

export const RESOLVED_STATUS_CODES = ['71_INAT', '75_INAT']

export const MOBILE_HOME_TABS = {
  SHIPMENTS: 'shipments',
  INCIDENTS: SHIPPING_STATUS_CODES.incidents,
}

export const SHIPPING_WITH_REFUND_CODE = 'REE'
export const SHIPPING_WITH_INSURANCE_MERCHAND_CODE = 'VDE'
export const SHIPPING_WITH_SLIP_SCAN = 'EAC'
export const SHIPPING_WITH_RETURN = 'RET'
export const SHIPPING_WITH_PUDO = 'PER'
export const SHIPPING_WITH_ORIGIN_PUDO = 'RDP'
export const SHIPPING_WITH_ERE = 'ERE'

export const IS_RESOLVING_INCIDENTS_ALLOWED = true
export const INCIDENT_CODE_INCORRECT_ADDRESS = '1_INCT'
export const INCIDENT_CODE_NO_ANSWER_RE = `2_INCT&${SHIPPING_STATUS_CODES.delivering}`
export const INCIDENT_CODE_NO_ANSWER = '2_INCT'
export const INCIDENT_CODE_NO_ANSWER_R = `2_INCT&${SHIPPING_STATUS_CODES.collected}`
export const INCIDENT_CODE_REFUSED = '4_INCT'
export const INCIDENT_CODE_NO_EFFECTIVE = '1005_INCT'
export const INCIDENT_CODE_RESOLVED = '50_INCT'
export const INCIDENTS_CODES_ALLOWED_FOR_RESOLUTION = [
  INCIDENT_CODE_INCORRECT_ADDRESS,
  INCIDENT_CODE_NO_ANSWER,
  INCIDENT_CODE_REFUSED,
  INCIDENT_CODE_NO_EFFECTIVE,
  INCIDENT_CODE_RESOLVED,
]

export const SERVICES_NAMES = {
  C24: 'CTT e24h',
  C48: 'CTT e48h',
  C14: 'CTT 14h',
  C10: 'CTT 10h',
  C14E: 'CTT Premium Empresas 14h',
  CCA24: 'CTT Canarias Aéreo',
  CCAE: 'CTT Canarias Documentación',
  CCAM: 'CTT Canarias Marítimo',
  CBA24: 'CTT Baleares Express',
  CBA48: 'CTT Baleares Economy',
  CIEX: 'CTT Internacional Express',
  CIES: 'CTT Internacional Economy',
  CIEL: 'CTT Internacional Europa Light',
}

export const CUSTOMS = {
  manifested: 'WEB0000',
  collected: 'WEB0500',
}

export const CUSTOM_SELECT_TYPE = [
  {
    id: 'PERSONAL_NATIONAL',
    text: 'shipping-send-form:customs:form:individual',
  },
  { id: 'BUSINESS_UNION', text: 'shipping-send-form:customs:form:company' },
]

export const CUSTOM_SELECT_REASON = [
  { id: 'SOLD', text: 'shipping-send-form:customs:form:select:sold' },
  {
    id: 'REPAIR_AND_RETURN',
    text: 'shipping-send-form:customs:form:select:repair_and_return',
  },
  { id: 'SAMPLE', text: 'shipping-send-form:customs:form:select:sample' },
  {
    id: 'PERSONAL_EFFECTS',
    text: 'shipping-send-form:customs:form:select:personal_effects',
  },
]

export const CUSTOM_FILE_TYPE = [
  {
    id: 'CERTIFICATE_OF_ORIGIN',
    text: 'shipping-send-form:customs:form:select:certificate_of_origin',
  },
  { id: 'OTHER', text: 'shipping-send-form:customs:form:select:other' },
]

export const WEB_VIDEOS = [
  {
    name: 'Píldora menú principal',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/Pildora%20men%C3%BA%20Principal.mp4',
  },
  {
    name: 'Píldora solicitar envío',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/P%C3%ADldora%20solicitar%20env%C3%ADo.mp4',
  },
  {
    name: 'Píldora seguimiento',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/P%C3%ADldora%20seguimiento.mp4',
  },
  {
    name: 'Píldora facturación',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/P%C3%ADldora%20facturaci%C3%B3n.mp4',
  },
  {
    name: 'Píldora ajustes de impresión',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/P%C3%ADldora%20ajustes%20de%20impresi%C3%B3n.mp4',
  },
  {
    name: 'Píldora ayuda y soporte',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/P%C3%ADldora%20ayuda%20y%20soporte.mp4',
  },
  {
    name: 'Píldora zona usuario',
    url: 'https://webcliente-staging.cttexpress.com/resources/assets/videos/P%C3%ADldora%20zona%20usuario.mp4',
  },
]
